import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { ComponentsService } from '../../services/ComponentsService';
import * as BullCache from "../../util/BullCache";
import { customStyles, the } from './customStyles';

const BrokerDropdown = ({ selectedAdmin, selectedMaster, setSelectedOption, setSelectedBrokerId, setSelectedSubBrokerId, menuPlacement }) => { 
  const [selectedOption, setSelectedOptionInternal] = useState(null);
  const [brokers, setBrokers] = useState([]);
  const [userBrokers, setUserBrokers] = useState([]); 


  var user = BullCache.getFromCache("user");

  useEffect(() => {
     setSelectedOptionInternal(null);
    setSelectedOption(null);

    const fetchBrokerData = async () => {
      let adminId = user?.adminId;

       if (selectedMaster) {
        adminId =  selectedMaster.value;
      }else if (selectedAdmin) {
        adminId =  selectedAdmin.value; 
      }

    if (adminId) {
      ComponentsService.getBrokers({ adminId }).then(res => {
        if (res.code === 1) {
          if (res.data.brokerList.length > 0) {
            setBrokers(res.data.brokerList);
          }
          else{
            setBrokers([]);
          }
        }
      });
    }
  };
  fetchBrokerData();
}, [selectedMaster, selectedAdmin]);

  const handleSelectChange = (selected) => {
    const userId = selected ? selected.value : null; 
    setSelectedOptionInternal(selected);
    setSelectedOption(selected); 
    setSelectedBrokerId(selected?.value); 
    setSelectedSubBrokerId(null);
  };

  const brokerOptions = brokers.map((item) => ({
    value: item.adminId,
    label: `${item.firstName} (${item.userName})`,
  })) || [];

  return (
    <div>
      <Select
        menuPlacement={menuPlacement}
        options={brokerOptions}
        value={selectedOption}
        onChange={handleSelectChange}
        placeholder="Select"
        isSearchable
        className="fss-01"
        size="sm"
        theme={the}
        styles={customStyles}
        isClearable
      />
    </div>
  );
};
export default BrokerDropdown;